import React, { useMemo } from 'react';
import { useCountdown } from '../../hook/useCountDown';
import { useDateFormat } from '../../hook/useDateFormat';

const H4 = 1000 * 60 * 60 * 4;

const Countdown = ({ timestamp, prefix }) => {
  const sDate = useMemo(() => new Date(timestamp), [timestamp]);

  const { timeLeftFormat: sFormat, timeLeft: sTimeLeft } = useCountdown(sDate);
  const { shortDateTime, shortDate } = useDateFormat();

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {sTimeLeft < H4 ? (
        `${prefix}: ${sFormat}`
      ) : (
        `${prefix}: ${shortDateTime(sDate)}`
      )}
    </div>
  );
};

export default Countdown;
